import { GetFilterItemsForCustomerForecastTimelineResponseAllOfResult } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';
import { ICustomerForecastDiffLastMonthBusinessData } from '../domains/entities/customerForecastDiffLastMonth';
import { ICustomerForecastDiffLastMonthBusinessDataFactory } from '../domains/factories/ICustomerForecastDiffLastMonthBusinessDataFactory';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 * APIから取得したデータをUI用に変換する
 */
export class GetCustomerForecastTimelineFilterItemsAdapter {
  /**
   * APIから取得したデータをUI用に変換する
   * @param response - APIから取得したデータ
   */
  public static adapt = (
    response: GetFilterItemsForCustomerForecastTimelineResponseAllOfResult
  ): ICustomerForecastDiffLastMonthBusinessData => {
    const data = response.data;
    return ICustomerForecastDiffLastMonthBusinessDataFactory.create({
      customerForecastStaffList:
        data.baseBusinessResponsibleUsers?.map((user) => UserAccountFactory.create({ email: user.id, name: user.name })) ?? [],
      businessId: data.baseBusinessId,
      supplierNumber: data.supplierNumber,
      supplierName: data.supplierName,
      businessNumber: data.businessNumber,
      businessName: data.businessName,
      package: data.package.addComma(),
      warehouseNumber: data.warehouseNumber,
      warehouse: data.warehouse,
      customerNumber: data.customerNumber,
      customerName: data.customerName,
      salesDestinationNumber: data.salesDestinationNumber,
      salesDestinationName: data.salesDestinationName,
    });
  };
}
